import React from "react"
import {Link, Image} from "components";
import PropTypes from "prop-types";
import mdToHtml from "../utils/mdToHtml";
import {media} from "../utils/media";
import isExternalUrl from "../utils/isExternalUrl";

const SectionTextImageBelow =  ({content}) => {
  if(!content.enabled) return false;
  return (
    <div className="section-future-wrapper">
      <div className="section-text">
        <h2 className="mb-20" dangerouslySetInnerHTML={{ __html: content.title }} />
        <div dangerouslySetInnerHTML={{ __html: mdToHtml(content.text) }} />
        <Link
          to={content.buttonUrl}
          // {...routes.about}
          className="button outline"
          external={isExternalUrl(content.buttonUrl)}
          dangerouslySetInnerHTML={{ __html: content.buttonText }}
        />
      </div>
      <div className="section-media">
        <Image
          url={media(content.deskImage)}
          alt={content.imageAlt}
          className="hide-mobile"
        />
        <Image
          url={media(content.mobImage)}
          alt={content.imageAlt}
          className="hide-desktop"
        />
      </div>
    </div>
  );
}

SectionTextImageBelow.propTypes = {
  content: PropTypes.object.isRequired,
};

SectionTextImageBelow.defaultProps = {
  content: {},
};

export default SectionTextImageBelow;
